import { createRouter, createWebHistory } from 'vue-router'
import { STORAGE_KEYS } from '@/config/app'
import { t } from '@/i18n'
import Home from '@/views/Home.vue'

let lastSessionCheck = 0
const SESSION_CHECK_INTERVAL = 30000

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: '/lobby',
    name: 'Lobby',
    component: () => import('@/views/Lobby.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/games',
    name: 'Games',
    component: () => import('@/views/Games.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/sportsbook',
    name: 'Sportsbook',
    component: () => import('@/views/Sportsbook.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/game/:id',
    name: 'GameView',
    component: () => import('@/views/GameView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    redirect: { path: '/', query: { auth: 'login' } }
  },
  {
    path: '/register',
    redirect: { path: '/', query: { auth: 'register' } }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import('@/views/Favorites.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/History.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/bonuses',
    name: 'Bonuses',
    component: () => import('@/views/Bonuses.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/responsible-gaming',
    name: 'ResponsibleGaming',
    component: () => import('@/views/ResponsibleGaming.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/vip',
    name: 'VIP',
    component: () => import('@/views/VIP.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const { useAuthStore } = await import('@/stores/auth')
  const authStore = useAuthStore()
  const storedToken = localStorage.getItem(STORAGE_KEYS.token)
  const now = Date.now()

  if (storedToken && !authStore.player) {
    const result = await authStore.restoreSession()
    if (!result.success) {
      const { useNotificationStore } = await import('@/stores/notifications')
      useNotificationStore().warning(t('session.expiredMessage'), t('session.expiredTitle'))
      return next({ path: '/', query: { auth: 'login' } })
    }
  } else if (storedToken && authStore.isAuthenticated && (now - lastSessionCheck) > SESSION_CHECK_INTERVAL) {
    lastSessionCheck = now
    const result = await authStore.refreshSession()
    if (!result.success) {
      const { useNotificationStore } = await import('@/stores/notifications')
      useNotificationStore().warning(t('session.expiredMessage'), t('session.expiredTitle'))
      return next({ path: '/', query: { auth: 'login' } })
    }
  }

  next()
})

export default router
